export default __webpack_public_path__ + "media/color/dock-3bda9932.svg";